import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, Div, Text, Input } from 'ui'
import { useResetPassword } from 'api/auth'
import { isValid } from 'ui/Input/validators'
import { useSession } from 'hooks'

import FormRequirement from '../FormRequirement'
import ResendCode from '../ResendCode'


const FormCodePassword = ({ onSuccess, mobileNumber }) => {

  const { t } = useTranslation()
  const { loginWithSecret } = useSession()

  const {
    data: resetData,
    resetPassword,
    isLoading,
    isSuccess,
    error
  } = useResetPassword()

  const [code, setCode] = useState('')
  const [codeError, setCodeError] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [confirmPasswordError, setConfirmPasswordError] = useState('')

  const isValidPwd = isValid.password(password)

  const handlePwd = (value) => {
    setPassword(value)
    setConfirmPasswordError('')
  }

  const handleConfirmPwd = (value) => {
    setConfirmPassword(value)
    setConfirmPasswordError('')
  }

  const handleChangeCode = (value) => {
    setCode(value)
    setCodeError('')
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    const isValidCode = isValid.smsCode(code)
    const isSamePwd = password === confirmPassword

    if (!isValidCode) {
      setCodeError(t('codeInvalid'))
    }

    if (!isSamePwd) {
      setConfirmPasswordError(t('passwordsDoesntMatch'))
    }

    if (!isValidCode || !isSamePwd) return

    resetPassword({ mobileNumber, code, password })
  }


  useEffect(() => {
    if (isSuccess) {
      onSuccess()
      loginWithSecret(resetData.secret)
    }
  }, [isSuccess])

  useEffect(() => {
    if (error?.name === 'ValidationError') setCodeError(t('invalidCode'))
  }, [error])


  return (
    <Div width='100%' display='flex' flexDirection='column'>

      <form onSubmit={handleSubmit}>
        <Text size='xl' align='center' color='headline'>
          {t('enterCodeAndCreateNewPwd')}
        </Text>

        <Div
          alignSelf='center'
          margin='0 auto'
          marginTop={32}
          maxWidth={350}
        >
          <Input.Code
            value={code}
            onChange={handleChangeCode}
            error={codeError}
          />
        </Div>

        <Div marginTop={18} marginBottom={24}>
          <ResendCode />
        </Div>
      </form>
      <form onSubmit={handleSubmit}>

        <Div display='flex' flexDirection='column' gap={16}>
          <Input.Password
            value={password}
            onChange={handlePwd}
            label={t('password')}
            autoComplete='new-password'
          />
          <Input.Password
            value={confirmPassword}
            onChange={handleConfirmPwd}
            label={t('repeatPassword')}
            autoComplete='new-password'
            error={confirmPasswordError}
          />
        </Div>

        <Div marginBottom={38}>
          <FormRequirement
            isCompleted={isValidPwd}
            description={t('passwordReqs')}
          />
        </Div>

        <Button
          size='large'
          isFull
          isLoading={isLoading}
          disabled={!isValidPwd}
        >
          {isLoading
            ? t('recoveringPassword')
            : t('recoverPassword')
          }
        </Button>
      </form>
    </Div>
  )
}

export default FormCodePassword